import { render, staticRenderFns } from "./AccesosIndividualesTab.vue?vue&type=template&id=47db60f7&scoped=true&lang=pug"
import script from "./AccesosIndividualesTab.vue?vue&type=script&lang=js"
export * from "./AccesosIndividualesTab.vue?vue&type=script&lang=js"
import style0 from "./AccesosIndividualesTab.vue?vue&type=style&index=0&id=47db60f7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47db60f7",
  null
  
)

export default component.exports